import { TreeView } from '@progress/kendo-react-treeview';
import { useEffect } from 'react';
import { useState } from 'react';



export const SBTreeView=({data,afterExpand,afterCheck,onItemClick,...props})=>{
    const [treeData,setTreeData]=useState(data);
    useEffect(()=>{
        setTreeData(data)
    },[data]);
    const handleAfterExpand=(e)=>{
        if(afterExpand)
        {
            afterExpand(e);
        }
    };
    const handleAfterCheck=(e)=>{
        if(afterCheck)
        {
            console.log(e,' in main Component')
  
            afterCheck(e);
        }
    };
    const handleOnItemClick=(e)=>{
        if(onItemClick)
        {
            onItemClick(e);
        }
    }
    return <TreeView
    data={treeData}
    className='sbaTree'
    onExpandChange={(e) => { handleAfterExpand(e) }}
    aria-multiselectable={true}
    onItemClick={(e) => { handleOnItemClick(e)}}
    onCheckChange={(e) => { handleAfterCheck(e) }}
    {...props}
  />
}